import { injectable, inject } from 'inversify';
import { RpcSuccess } from '@dealroadshow/json-rpc-dispatcher';
import Request from '@/Framework/api/Rpc/Request';
import RpcDispatcher from '@/finsight/application/DI/Rpc/finsight-web/HttpDispatcher';
import { ISubscriptionsPayload } from '@/finsight/domain/vo/Subscriptions';
import { IUserSubscriptionsResponse } from '@/finsight/domain/vo/Subscriptions/userSubscriptions';

@injectable()
class SubscriptionsRepository {
  constructor(@inject(RpcDispatcher) protected readonly rpc: typeof RpcDispatcher) {}

  getSubscribersListByAdmin = async (payload) => {
    const request = new Request('finsight_web.subscription.get_subscribers', payload);
    const response = await this.rpc.call<RpcSuccess>(request);

    return response.getResult().payload;
  };

  updateUserSubscriptionsByAdmin = async (payload) => {
    const request = new Request('finsight_web.subscription.update_by_admin', payload);
    const response = await this.rpc.call<RpcSuccess>(request);

    return response.getResult().payload;
  };

  subscribeMultipleUsersByAdmin = async (payload) => {
    const request = new Request('finsight_web.subscription.multiple_subscriptions', payload);
    const response = await this.rpc.call<RpcSuccess>(request);

    return response.getResult().payload;
  };

  getUserSubscriptionsByAdmin = async (payload) => {
    const request = new Request('finsight_web.subscription.get_subscription_list_by_admin', payload);
    const response = await this.rpc.call<RpcSuccess>(request);

    return response.getResult().payload;
  };

  getSubscriptionsListByAdmin = async (payload = {}) => {
    const request = new Request('finsight_web.subscription.get_subscriptions', payload);
    const response = await this.rpc.call<RpcSuccess>(request);

    return response.getResult().payload;
  };

  getUserSubscriptionsBySSID = async (): Promise<IUserSubscriptionsResponse> => {
    const request = new Request('finsight_web.subscription.get_my_subscriptions_by_ssid', {});
    const response = await this.rpc.call<RpcSuccess>(request);

    return response.getResult().payload;
  };

  getUserSubscriberHash = async (payload) => {
    const request = new Request('finsight_web.subscription.get_subscriber_by_subscription_hash', payload);
    const response = await this.rpc.call<RpcSuccess>(request);

    return response.getResult().payload;
  };

  updateUserSubscriptionsBySSID = async (payload: ISubscriptionsPayload): Promise<null> => {
    const request = new Request('finsight_web.subscription.update_my_subscriptions_by_ssid', payload);
    const response = await this.rpc.call<RpcSuccess>(request);

    return response.getResult().payload;
  };

  updateUserSubscriptionsByHash = async (payload) => {
    const request = new Request('finsight_web.subscription.update_my_subscriptions_by_hash', payload);
    const response = await this.rpc.call<RpcSuccess>(request);

    return response.getResult().payload;
  };

  createUserSubscriptionBySSID = async (payload) => {
    const request = new Request('finsight_web.subscription.subscribe_by_ssid', payload);
    const response = await this.rpc.call<RpcSuccess>(request);

    return response.getResult().payload;
  };

  createUserSubscriptionByEmail = async (payload) => {
    const request = new Request('finsight_web.subscription.subscribe_by_email', payload);
    const response = await this.rpc.call<RpcSuccess>(request);

    return response.getResult().payload;
  };

  checkUserSubscriptionStatus = async (payload: ISubscriptionsPayload): Promise<boolean> => {
    const request = new Request('finsight_web.subscription.check_status', payload);
    const response = await this.rpc.call<RpcSuccess>(request);

    return response.getResult().payload;
  };
}

export default SubscriptionsRepository;
